import types from './types';

const defaultState = {
  possibleColumnsList: [],
  visibleColumnsList: [],
  possibleFieldsList: [],
  visibleFieldsList: [],
  filteredList: { result: [], totalPages: '0', totalElements: '0' },
  isLoading: false,
  isLoadingFilter: false
};

const entityState = {
  filters: {},
  possibleFieldsList: [],
  visibleFieldsList: [],
  possibleColumnsList: [],
  visibleColumnsList: [],
  filteredList: { result: [], totalPages: 0, totalElements: 0 },
  isLoading: false,
  elasticSearchFiltering: false,
  isLoadingFilter: false
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.INITIALIZE_FILTERING:
      return {
        ...state,
        [params.entityType]: {
          ...entityState,
          possibleFieldsList: [],
          visibleFieldsList: [],
          possibleColumnsList: [],
          visibleColumnsList: [],
          isLoading: true
        }
      };

    case types.INITIALIZE_FILTERING_SUCCESS:
      return {
        ...state,
        [request.params.entityType]: {
          ...state[request.params.entityType],
          possibleFieldsList: data.possibleFieldsList,
          visibleFieldsList: data.visibleFieldsList,
          possibleColumnsList: data.possibleColumnsList,
          visibleColumnsList: data.visibleColumnsList,
          isLoading: false
        }
      };

    case types.APPLY_FILTERS_V2:
      return {
        ...state,
        [params.entityType]: {
          ...state[params.entityType],
          isLoadingFilter: true,
          filters: params.filters ? params.filters : state[params.entityType].filters
        }
      };
    case types.APPLY_FILTERS_SUCCESS_V2: {
      const { aggs, ...filteredList } = data;
      return {
        ...state,
        [request.params.entityType]: {
          ...state[request.params.entityType],
          filteredList,
          aggs,
          isLoadingFilter: false
        }
      };
    }
    case types.APPLY_FILTERS_FAILURE_V2:
      return {
        ...state,
        [request.params.entityType]: {
          ...state[request.params.entityType],
          isLoadingFilter: false
        }
      };

    default:
      return state;
  }
};
